import { render, staticRenderFns } from "./Check_Document.vue?vue&type=template&id=1f996eb0&"
import script from "./Check_Document.vue?vue&type=script&lang=js&"
export * from "./Check_Document.vue?vue&type=script&lang=js&"
import style0 from "./Check_Document.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports